{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Annuller",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integrationer",
    "DESCRIPTION": "Kontaktcentret integrerer med flere værktøjer og tjenester for at forbedre dit teams effektivitet. Udforsk listen nedenfor for at konfigurere dine foretrukne apps.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Abonnerede Begivenheder",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Annuller",
        "DESC": "Webhook-begivenheder giver dig realtidsoplysninger om, hvad der sker på din konto. Angiv en gyldig URL for at konfigurere et callback.",
        "SUBSCRIPTIONS": {
          "LABEL": "Begivenheder",
          "EVENTS": {
            "INBOX_CREATED": "Indbakke Oprettet",
            "CONVERSATION_CREATED": "Samtale Oprettet",
            "CONVERSATION_STATUS_CHANGED": "Samtale Status Ændret",
            "CONVERSATION_UPDATED": "Samtale Opdateret",
            "MESSAGE_CREATED": "Besked oprettet",
            "MESSAGE_UPDATED": "Besked opdateret",
            "WEBWIDGET_TRIGGERED": "Live chat widget åbnet af brugeren",
            "CONTACT_CREATED": "Contact created",
            "CONTACT_UPDATED": "Contact updated",
            "JARABOT_EVENT": "Internal events"
          }
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Angiv en gyldig URL"
        },
        "EDIT_SUBMIT": "Opdater webhook",
        "ADD_SUBMIT": "Opret webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Konfigurer",
      "HEADER": "Webhook indstillinger",
      "HEADER_BTN_TXT": "Tilføj ny webhook",
      "LOADING": "Henter vedhæftede webhooks",
      "SEARCH_404": "Der er ingen elementer, der matcher denne forespørgsel",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks er HTTP tilbagekald som kan defineres for hver konto. De udløses af begivenheder som oprettelse af beskeder. Du kan oprette mere end én webhook for denne konto. <br /><br /> For at oprette en <b>webhook</b>, klik på <b>Tilføj ny webhook</b> knappen. Du kan også fjerne enhver eksisterende webhook ved at klikke på Slet knappen.</p>",
      "LIST": {
        "404": "Der er ingen webhooks konfigureret til denne konto.",
        "TITLE": "Administrer webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook endepunkt",
          "ACTIONS": "Handlinger"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Rediger",
        "TITLE": "Rediger webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfiguration opdateret",
          "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
        }
      },
      "ADD": {
        "CANCEL": "Annuller",
        "TITLE": "Tilføj ny webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfiguration tilføjet",
          "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Slet",
        "API": {
          "SUCCESS_MESSAGE": "Webhook blev slettet",
          "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
        },
        "CONFIRM": {
          "TITLE": "Bekræft Sletning",
          "MESSAGE": "Er du sikker på at du vil slette webhook? ({webhookURL})",
          "YES": "Ja, Slet ",
          "NO": "Nej, behold det"
        }
      },
      "DISABLED_BADGE": "Deaktiveret",
      "DISABLED_REASON": "Automatisk deaktiveret efter {count} på hinanden følgende fejl. Seneste fejl: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Aktiver",
        "API": {
          "SUCCESS_MESSAGE": "Webhook aktiveret",
          "ERROR_MESSAGE": "Kunne ikke aktivere webhook, prøv igen senere"
        }
      }
    },
    "SLACK": {
      "DELETE": "Slet",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete the integration",
        "MESSAGE": "Are you sure you want to delete the integration? Doing so will result in the loss of access to conversations on your Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Brug Slack Integration",
        "BODY": "Med denne integration bliver alle dine indgående samtaler synkroniseret til kanalen ***{selectedChannelName}*** i dit Slack-workspace. Du kan håndtere alle dine kundesamtaler direkte i kanalen og aldrig gå glip af en besked.\n\nHer er integrationens vigtigste funktioner:\n\n**Svar på samtaler inde fra Slack:** For at svare på en samtale i Slack-kanalen ***{selectedChannelName}*** skal du skrive din besked og sende den som en tråd. Det opretter et svar til kunden via kontaktcentret. Så enkelt er det!\n\n **Opret private noter:** Hvis du vil oprette private noter i stedet for svar, skal du starte din besked med ***`note:`***. Det sikrer, at din besked forbliver privat og ikke er synlig for kunden.\n\n**Tilknyt en agentprofil:** Hvis den person, der svarede i Slack, har en agentprofil i kontaktcentret med den samme e-mail, bliver svarene automatisk tilknyttet den agentprofil. Det betyder, at du nemt kan se, hvem der sagde hvad og hvornår. Hvis den, der svarer, ikke har en tilknyttet agentprofil, vises svarene for kunden fra botprofilen.",
        "SELECTED": "selected"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Select a channel",
        "UPDATE": "Opdater",
        "BUTTON_TEXT": "Connect channel",
        "DESCRIPTION": "Dit Slack-workspace er nu forbundet med kontaktcentret. Integrationen er dog inaktiv i øjeblikket. Klik på knappen nedenfor for at aktivere integrationen og forbinde en kanal.\n\n**Bemærk:** Hvis du forsøger at forbinde en privat kanal, skal du tilføje vores app til Slack-kanalen, før du fortsætter med dette trin.",
        "ATTENTION_REQUIRED": "Attention required",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "The channel is connected successfully",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Assist",
      "WITH_AI": " {option} med AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Svarforslag",
        "SUMMARIZE": "Opsummer",
        "REPHRASE": "Forbedr skrivning",
        "FIX_SPELLING_GRAMMAR": "Ret stavning og grammatik",
        "SHORTEN": "Forkort",
        "EXPAND": "Udvid",
        "MAKE_FRIENDLY": "Skift beskedens tone til venlig",
        "MAKE_FORMAL": "Brug en formel tone",
        "SIMPLIFY": "Forenkl",
        "TRANSLATE": "Oversæt",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Oversæt til flertalssprog"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Udkastindhold",
        "GENERATED_TITLE": "Genereret indhold",
        "AI_WRITING": "AI skriver",
        "BUTTONS": {
          "APPLY": "Brug dette forslag",
          "CANCEL": "Annuller"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrer med OpenAI",
        "DESC": "Få avancerede AI-funktioner i dit dashboard med OpenAI's GPT-modeller. Indtast API-nøglen fra din OpenAI-konto for at komme i gang.",
        "KEY_PLACEHOLDER": "Indtast din OpenAI API-nøgle",
        "BUTTONS": {
          "NEED_HELP": "Brug for hjælp?",
          "DISMISS": "Dismiss",
          "FINISH": "Afslut konfiguration"
        },
        "DISMISS_MESSAGE": "Du kan konfigurere OpenAI-integrationen senere, når du vil.",
        "SUCCESS_MESSAGE": "OpenAI-integrationen blev konfigureret."
      },
      "TITLE": "Forbedr med AI",
      "SUMMARY_TITLE": "Resumé med AI",
      "REPLY_TITLE": "Svarforslag med AI",
      "SUBTITLE": "Et forbedret svar genereres ved hjælp af AI, baseret på dit nuværende udkast.",
      "TONE": {
        "TITLE": "Tone",
        "OPTIONS": {
          "PROFESSIONAL": "Professionel",
          "FRIENDLY": "Venlig"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generer",
        "GENERATING": "Genererer...",
        "CANCEL": "Annuller"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Slet",
      "API": {
        "SUCCESS_MESSAGE": "Integrationen blev slettet"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Tilslut"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Dashboard Apps",
      "HEADER_BTN_TXT": "Tilføj en ny dashboard app",
      "SIDEBAR_TXT": "<p><b>Dashboard Apps</b></p><p>Dashboard Apps tillader organisationer at integrere en applikation i dashboardet for at give konteksten til kundesupportagenter. Denne funktion giver dig mulighed for at oprette et program uafhængigt og integrere at inde i instrumentbrættet til at give brugerinformation, deres ordrer eller deres tidligere betalingshistorie.</p><p>Når du indlejrer din applikation i dashboardet, vil dit program få konteksten af samtalen og kontakt som en vinduesbegivenhed. Gennemfør en lytter til besked begivenheden på din side for at modtage konteksten.</p><p>For at tilføje en ny dashboard app, klik på knappen 'Tilføj en ny dashboard app'.</p>",
      "DESCRIPTION": "Dashboard Apps giver organisationer mulighed for at integrere et program i instrumentbrættet for at give konteksten for kundesupportagenter. Denne funktion giver dig mulighed for at oprette et program uafhængigt og integrere at give brugeroplysninger, deres ordrer, eller deres tidligere betalingshistorik.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "Der er ingen dashboard apps konfigureret på denne konto endnu",
        "LOADING": "Henter dashboard apps...",
        "TABLE_HEADER": {
          "NAME": "Navn",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Rediger app",
        "DELETE_TOOLTIP": "Slet app"
      },
      "FORM": {
        "TITLE_LABEL": "Navn",
        "TITLE_PLACEHOLDER": "Angiv et navn til din dashboard app",
        "TITLE_ERROR": "Et navn til dashboard app er påkrævet",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Angiv slutpunktets URL, hvor din app er vært",
        "URL_ERROR": "En gyldig URL er påkrævet"
      },
      "CREATE": {
        "HEADER": "Tilføj en ny dashboard app",
        "FORM_SUBMIT": "Send",
        "FORM_CANCEL": "Annuller",
        "API_SUCCESS": "Dashboard app konfigureret",
        "API_ERROR": "Vi kunne ikke oprette en app. Prøv igen senere"
      },
      "UPDATE": {
        "HEADER": "Rediger dashboard app",
        "FORM_SUBMIT": "Opdater",
        "FORM_CANCEL": "Annuller",
        "API_SUCCESS": "Dashboard app opdateret",
        "API_ERROR": "Vi kunne ikke opdatere appen. Prøv igen senere"
      },
      "DELETE": {
        "CONFIRM_YES": "Ja, slet det",
        "CONFIRM_NO": "Nej, behold det",
        "TITLE": "Bekræft sletning",
        "MESSAGE": "Er du sikker på at du vil slette appen - {appName}?",
        "API_SUCCESS": "Dashboard app slettet",
        "API_ERROR": "Vi kunne ikke slette appen. Prøv igen senere"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Opret",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Link",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Titel",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Titel er påkrævet"
          },
          "DESCRIPTION": {
            "LABEL": "Beskrivelse",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Team",
            "PLACEHOLDER": "Vælg hold",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Priority",
            "PLACEHOLDER": "Select priority",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Etiketter",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Status",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Opret",
        "CANCEL": "Annuller",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Status",
        "PRIORITY": "Priority",
        "ASSIGNEE": "Assignee",
        "LABELS": "Etiketter",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Yes, delete",
        "CANCEL": "Annuller"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Send besked...",
      "EMPTY_MESSAGE": "Der opstod en fejl under generering af svaret. Prøv venligst igen.",
      "LOADER": "Captain is thinking",
      "YOU": "Dig",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Annuller",
      "CREATE": "Opret",
      "EDIT": "Opdater"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Funktioner",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Slet",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Alle"
      },
      "STATUS": {
        "TITLE": "Status",
        "PENDING": "Afventer",
        "APPROVED": "Approved",
        "ALL": "Alle"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Afbryd"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Indbakke",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
